/**
 * Triggers communication (Chat or Call) from any component
 */
export const startCommunication = (navigate, toId, action = "chat") => {
  if (!toId) {
    console.error("Communication Error: No User ID provided.");
    return;
  }

  if (action === "chat") {
    // Regular navigation to chat
    navigate(`/chat/${toId}`);
  } else {
    // Navigation to chat with a trigger for the call (audio or video)
    navigate(`/chat/${toId}?call=${action}`);
  }
};